import { render, staticRenderFns } from "./ModaNewItems.vue?vue&type=template&id=6abe44d6"
import script from "./ModaNewItems.vue?vue&type=script&lang=js"
export * from "./ModaNewItems.vue?vue&type=script&lang=js"
import style0 from "./ModaNewItems.vue?vue&type=style&index=0&id=6abe44d6&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6abe44d6')) {
      api.createRecord('6abe44d6', component.options)
    } else {
      api.reload('6abe44d6', component.options)
    }
    module.hot.accept("./ModaNewItems.vue?vue&type=template&id=6abe44d6", function () {
      api.rerender('6abe44d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/productiveAreas/detail/component/ModaNewItems.vue"
export default component.exports